import pym from 'pym.js';
// get the app name and url from wp_localize_script.
const pymParent = new pym.Parent(
  window.patientAdvocacy.name,
  window.patientAdvocacy.url,
  {}
);
const ln = window.location;

/**
 * Update the parent site with URL fragment.
 * @see http://blog.apps.npr.org/pym.js/api/pym.js/1.3.2/module-pym.Parent.html#onMessage
 */
pymParent.onMessage('location', (data) => {
  if (history.pushState) {
    const fragment = data.replace('/patient-advocacy', '');
    const appUrl = `${ln.protocol}//${ln.host}${ln.pathname}#${fragment}`;
    window.history.pushState({ path: appUrl }, '', appUrl);
  }
});

/**
 * Send the app path back to the child with forward slashes.
 * @see http://blog.apps.npr.org/pym.js/api/pym.js/1.3.2/module-pym.Parent.html#sendMessage
 */
pymParent.onMessage('childLoaded', () => {
  // on child load send message.
  pymParent.sendMessage(
    'path',
    ln.hash.substr(1).replace(/-/g, '/').replace('+', '?')
  );
});
